import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IItemApkForAssign } from 'types';
import { allApkTypes } from 'appConstants';
import { Checkbox } from 'antd';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import classNames from 'classnames';
import style from './Apk.module.scss';

interface IApk {
	data: IItemApkForAssign;
}

const Apk: React.FC<IApk> = ({ data }) => {
	const { setIDsSelectedApk, IDsSelectedApk } = useContext<IApkAssignmentContext>(ApkAssignmentContext);
	const checkCheckbox = () => IDsSelectedApk.includes(data.id);
	const isCheckedCheckbox = useMemo(() => checkCheckbox(), [data, IDsSelectedApk]);
	const getApkTypeName = () => allApkTypes.find((el) => el.apkTypeID === data.type)?.apkTypeName || null;
	const apkTypeName = useMemo(() => getApkTypeName(), []);

	const containerClasses = classNames(style.container, {
		[style.hasAssign]: !data.unassigned,
		[style.checkedCheckbox]: isCheckedCheckbox,
	});

	const handleChange = (value: boolean) => {
		if (value) {
			setIDsSelectedApk([...IDsSelectedApk, data.id]);
		} else {
			const updatedApkList = IDsSelectedApk.filter((el) => el !== data.id);
			setIDsSelectedApk(updatedApkList);
		}
	};

	return (
		<div className={containerClasses} data-test="Apk">
			<div className={style.name}>
				<Checkbox
					className={style.checkbox}
					onChange={(e) => handleChange(e.target.checked)}
					checked={isCheckedCheckbox}
				/>
				<Text translationKey={data.versionName} withTooltip={true} />
			</div>
			<Text className={style.type} translationKey={apkTypeName} withTooltip={true} />
		</div>
	);
};

export default Apk;
